import {Component, inject, Renderer2, signal} from '@angular/core'
import {MatIconButton} from '@angular/material/button'
import {MatIcon} from '@angular/material/icon'


@Component({
  selector: 'aku-toggle-button',
  imports: [
    MatIcon,
    MatIconButton
  ],
  templateUrl: './toggle-button.component.html'
})
export class ToggleButtonComponent {
  /* v8 ignore next @preserve */
  public theme = signal(false)

  private readonly renderer = inject(Renderer2)

  public toggle(mode: 'dark' | 'light') {
    this.theme.update(t => !t)
    this.renderer.setStyle(document.body, 'color-scheme', mode)
  }
}
